/*
  components/Header
*/

import React, { Component } from 'react'
//import Colors from 'material-ui/styles/colors'
import Icon from 'react-icons-kit'
import { ic_phone as mdIc_phone } from 'react-icons-kit/md/ic_phone'
import { ic_mail as mdIc_mail } from 'react-icons-kit/md/ic_mail'
import { ic_menu as mdIc_menu } from 'react-icons-kit/md/ic_menu'
import { whatsapp as faWhatsapp } from 'react-icons-kit/fa/whatsapp'
import { ic_schedule as mdIc_schedule } from 'react-icons-kit/md/ic_schedule'
import { ic_arrow_drop_down as mdIc_arrow_drop_down } from 'react-icons-kit/md/ic_arrow_drop_down'
import { facebookSquare as faFacebookSquare } from 'react-icons-kit/fa/facebookSquare'
import { Link } from 'react-router-dom'
import {
  IconButton,
  RaisedButton,
  Paper,
  Menu,
  IconMenu,
  MenuItem,
  Divider
} from 'material-ui'
import BreakPoint from '../../responsive-utilities/breakpoint'
//import data from '../../data'
import './style.css'
import logo from '../../assets/img/logo.png'
import iconWaze from '../../assets/img/waze-2.png'
import { GridList, GridTile } from 'material-ui/GridList'
import { List, ListItem } from 'material-ui/List'
import Subheader from 'material-ui/Subheader'
import StarBorder from 'material-ui/svg-icons/toggle/star-border'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

const styles = {
  iconWaze: {
  },
}
const style = {
  display: 'inline-block',
  // margin: '16px 32px 16px 0',
}
const gridStyles = {
  root: {
    /*
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    */
  },
  gridList: {
    overflow: 'hidden',
  },
}

class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openPhoneDialog: false,
      openScheduleDialog: false,
      menuProducts: false,
      menuServices: false,
      menuTests: false,
    }
  }

  menus = {}

  openPhoneDialog = () => {
    this.setState({ openPhoneDialog: true })
  }

  closePhoneDialog = () => {
    this.setState({ openPhoneDialog: false })
  }

  openScheduleDialog = () => {
    this.setState({ openScheduleDialog: true })
  }

  closeScheduleDialog = () => {
    this.setState({ openScheduleDialog: false })
  }

  openWaze = (e) => {
    const { data } = this.props

    window.location = data.waze.appLink
    e.preventDefault()

    setTimeout(() => {
      let windowRef = window.open(data.waze.fallbackLink, '_blank', 'noopener,noreferrer')
      windowRef && (windowRef.opener = null)
    }, 500)
  }

  closeMenu = () => {
    // console.log(this.menus)
    Object.keys(this.menus).map((key, index) => {
      this.menus[key].state.open = false
    })
  }

  render() {
    const { menuItems, actions, data, ...rest } = this.props

    const { dataCondition } = this.props

    return (
      <header className="header" {...rest}>
        <nav className="topbar" style={styles.topbar}>
          <div className="container">
            <BreakPoint query="xs">
              {(matches) => {
                if (matches) {
                  return (
                    <div className="content">
                      <div className="center">
                        <a onClick={this.openScheduleDialog} title="Opening Hours">
                          <Icon className="icon" icon={mdIc_schedule} size={24} />
                        </a>
                        {/* <a href={`tel:${data.phone[0].replace(/ /g, '')}`} title="Call Us">
                          <Icon className="icon" icon={mdIc_phone} size={24} />
                          {false && 'Call Us'}
                        </a> */}
                        <a onClick={this.openPhoneDialog} title="Call Us">
                          <Icon className="icon" icon={mdIc_phone} size={24} />
                          {false && 'Call Us'}
                        </a>
                        <a onClick={this.openWaze} title="Visit Us">
                          <img src={iconWaze} className="icon" style={styles.iconWaze} alt="Open with Waze" />
                          {false && 'Visit Us'}
                        </a>
                        <a href={`mailto:${data.email}`} title="Send Enquiry">
                          <Icon className="icon" icon={mdIc_mail} size={24} />
                          {false && 'Send Enquiry'}
                        </a>
                        {!!data.facebook && !!data.facebook.pageLink &&
                          <a href={data.facebook.pageLink} title="Facebook" target="_blank" rel="noopener noreferrer">
                            <Icon className="icon" icon={faFacebookSquare} size={24} />
                            {false && 'Facebook'}
                          </a>
                        }
                      </div>
                    </div>
                  )
                } else {
                  return (
                    <div className="content">
                      <div className="left">
                        <a onClick={this.openScheduleDialog} title="Opening Hours">
                          <Icon className="icon" icon={mdIc_schedule} />
                          {
                            !!data.openingHours && (Object.keys(data.openingHours) || []).filter(k => !!data.openingHours[k].summary).map((key, index) => {
                              return (
                                <span key={index} style={{ marginRight: 8 }}>
                                  {[
                                    data.openingHours[key].label,
                                    data.openingHours[key].value,
                                  ].join(', ')}
                                </span>
                              )
                            })
                          }
                        </a>
                      </div>
                      <div className="center">
                        <div style={{ display: 'flex' }}>
                        </div>
                      </div>
                      <div className="right">
                        <BreakPoint query="lgUp" style={{ display: 'flex' }}>
                          <Link to="/about">
                            About
                          </Link>
                          <Link to="/contact">
                            Contact
                          </Link>
                          {/* <Link to="/news-media">
                            News &amp; Media
                          </Link> */}
                          <Link to="/appointment">
                            Appointment
                          </Link>
                        </BreakPoint>
                        <a href={`mailto:${data.email}`} title="Send Enquiry">
                          <Icon className="icon" icon={mdIc_mail} />
                          <BreakPoint query="mdUp">
                            {data.email}
                          </BreakPoint>
                        </a>
                        <a href={`tel:${data.phone[0].number.replace(/ /g, '')}`} title="Call Us">
                          <Icon className="icon" icon={mdIc_phone} />
                          <BreakPoint query="mdUp">
                            {data.phone[0].number}
                          </BreakPoint>
                        </a>
                        <a onClick={this.openWaze} title="Visit Us">
                          <img src={iconWaze} className="icon small" style={styles.iconWaze} alt="Open with Waze" />
                        </a>
                        {!!data.facebook && !!data.facebook.pageLink &&
                          <a href={data.facebook.pageLink} title="Facebook" target="_blank" rel="noopener noreferrer">
                            <Icon className="icon" icon={faFacebookSquare} />
                            {false && 'Facebook'}
                          </a>
                        }
                      </div>
                    </div>
                  )
                }
              }}
            </BreakPoint>
          </div>
        </nav>
        <div className="container">
          <nav className="menu">
            <div className="left">
              <BreakPoint query="mdDown">
                <IconButton className="item" onClick={actions.openDrawer}>
                  <Icon icon={mdIc_menu} size={24} />
                </IconButton>
              </BreakPoint>
              <BreakPoint query="xs">
                {(matches) => {
                  if (matches) {
                    return (
                      <Link to="/" onClick={() => this.closeMenu()}>
                        <img src={logo} className="logo logo-square" alt={data.name} />
                      </Link>
                    )
                  } else {
                    return (
                      <Link to="/" onClick={() => this.closeMenu()}>
                        <img src={logo} className="logo" alt={data.name} />
                      </Link>
                    )
                  }
                }}
              </BreakPoint>
            </div>
            <div className="right">
              {menuItems.map((item, key) => {
                const skip = {
                  'About': true,
                  'Contact': true,
                  'News & Media': true,
                }
                const viewHeight = window.innerHeight
                  || document.documentElement.clientHeight
                  || document.body.clientHeight

                return (
                  <BreakPoint query="lgUp" className="item" key={key}>
                    {!item.items && !skip[item.label] &&
                      <Link {...item.props} onClick={() => this.closeMenu()}>
                        {item.label}
                      </Link>
                    }
                    {item.items && item.items.length && !skip[item.label] &&
                      <IconMenu
                        iconButtonElement={
                          <a>
                            {item.label}
                            <Icon icon={mdIc_arrow_drop_down} size={18} className="icon" />
                          </a>
                        }
                        className="dropdown"
                        maxHeight={viewHeight - 200}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        targetOrigin={{ vertical: 'top', horizontal: 'right' }}
                        ref={(ref) => (this.menus.tests = ref)}
                        desktop={item.items && item.items.length > 10}
                      >
                        {item.items.map((subItem, subKey) => {
                          return (
                            <MenuItem primaryText={subItem.label} key={subKey} containerElement={
                              <Link {...subItem.props} />
                            } />
                          )
                        })}
                      </IconMenu>
                    }
                    {item.label == 'Services' &&

                      <IconMenu
                        iconButtonElement={
                          <a>
                            {item.label}
                            <Icon icon={mdIc_arrow_drop_down} size={18} className="icon" />
                          </a>
                        }
                        className="dropdown"
                        maxHeight={viewHeight - 200}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        targetOrigin={{ vertical: 'top', horizontal: 'right' }}
                        ref={(ref) => (this.menus.services = ref)}
                      >
                        <div style={styles.root}>
                          <GridList
                            cols={2}
                            padding={1}
                            cellHeight={380}
                            style={gridStyles.gridList}
                          >
                            {

                              item.items.map((subItem, subKey) => {
                                {/* console.log(subItem)  */ }
                                return (
                                  [
                                    Object.values(subItem).map((childItem, childKey) => {
                                      {/* console.log(childItem)  */ }

                                      return (
                                        <Paper
                                          style={style}
                                          cols={1}
                                          rows={1}
                                          className="dropdown-paper"
                                        >
                                          <div className="dropdown-title">{childItem.label}</div>
                                          <ul>
                                            {

                                              childItem.child.map((egde, adeKey) => {
                                                {/* console.log(egde.smallChild)    */ }
                                                if (!egde.smallChild) {
                                                  return (
                                                    <li className="dropdown-menu-item" key={adeKey}>
                                                      <Link to={egde.props.to}
                                                        onClick={() => this.closeMenu()}
                                                      >
                                                        {egde.label}
                                                      </Link>
                                                    </li>
                                                  )
                                                } else {
                                                  return (
                                                    <Paper
                                                      style={style}
                                                      cols={1}
                                                      rows={1}
                                                      className="dropdown-paper has-child"
                                                      key={adeKey}
                                                    >
                                                      <div className="dropdown-title-small">{egde.label}</div>
                                                      {
                                                        egde.smallChild.map((smalChild, degKey) => {
                                                          return (
                                                            <li className="dropdown-menu-item" key={degKey}>
                                                              <Link to={smalChild.props.to}
                                                                onClick={() => this.closeMenu()}
                                                              >
                                                                {smalChild.label}
                                                              </Link>
                                                            </li>
                                                          )
                                                        })
                                                      }
                                                    </Paper>
                                                  )
                                                }

                                              })
                                            }
                                          </ul>
                                        </Paper>
                                      )
                                    })
                                  ]
                                )
                              })
                            }

                          </GridList>
                        </div>
                      </IconMenu>
                    }
                  </BreakPoint>
                )
              })}
              {false &&
                <BreakPoint query="lgUp">
                  <div className="item">
                    <Link to="/appointment">
                      <RaisedButton primary={true} className="button-appointment" label="Book Appointment" />
                    </Link>
                  </div>
                </BreakPoint>
              }
            </div>
          </nav>
        </div>
        <Dialog
          title="Call Us"
          actions={[
            <FlatButton
              label="Close"
              primary={true}
              onClick={this.closePhoneDialog}
            />,
          ]}
          autoScrollBodyContent={true}
          modal={false}
          open={this.state.openPhoneDialog}
          onRequestClose={this.closePhoneDialog}
          titleStyle={{
            paddingBottom: 0,
          }}
          bodyStyle={{
            padding: 0,
          }}
          contentStyle={{
            maxWidth: '400px',
            width: 'calc(100% - 2rem)',
          }}
        >
          <List>
            {data.phone.map((phone, index) => {
              return (
                <ListItem
                  leftIcon={<Icon icon={mdIc_phone} size={24} />}
                  primaryText={phone.number}
                  secondaryText={phone.label}
                  key={index}
                  href={`tel:${phone.number.replace(/[\s-]/g, '')}`}
                />
              )
            })}
            {data.whatsapp.map((phone, index) => {
              return (
                <ListItem
                  leftIcon={<Icon icon={faWhatsapp} size={24} />}
                  primaryText={phone.number}
                  secondaryText={phone.label}
                  key={index}
                  href={`https://wa.me/${phone.number.replace(/[\s-+]/g, '')}`}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                />
              )
            })}
          </List>
        </Dialog>
        <Dialog
          title="Opening Hours"
          actions={[
            <FlatButton
              label="Close"
              primary={true}
              onClick={this.closeScheduleDialog}
            />,
          ]}
          autoScrollBodyContent={true}
          modal={false}
          open={this.state.openScheduleDialog}
          onRequestClose={this.closeScheduleDialog}
          contentStyle={{ maxWidth: '300px' }}
        >
          {
            !!data.openingHours && Object.keys(data.openingHours).map((key, index) => {
              return (
                <div key={index}>
                  <h4 style={{ marginBottom: '.5rem' }}>
                    {data.openingHours[key].label}
                  </h4>
                  <div>
                    {data.openingHours[key].value}
                  </div>
                </div>
              )
            })
          }
        </Dialog>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js